import { ActionButton } from '@agilepoint/wat-react-ux';
import styled from 'styled-components';

export const IconButton = styled(ActionButton)`
    height: 16px;
    width: 16px;
    outline-offset: 5px;

    .ap-icon {
        margin: 0px;
        fill: ${({ theme: { mobileAppAccelerator: { semanticColors } } }) => semanticColors.grayVariant3};
    }
`;
